import React from "react";
import { Background } from "../../../BuildingBlocks/Background";
import { FrontColors } from "../../../../models/FrontColors";
import { Flex } from "../../../BuildingBlocks/Flex";
import { FPMarketingSectionTitle } from "../../Simple/FPMarketingSectionTitle/FPMarketingSectionTitle";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { FPFooter } from "../../Simple/FPFooter/FPFooter";
import { pipe } from "fp-ts/lib/function";
import { array } from "fp-ts";
import { FrontSpacing } from "../../../../models/FrontSpacing";
import { FPGuideMobile } from "../../Simple/FPGuide/FPGuideMobile";
import { fpLandingPageGuidesViewGuides } from "./FPLandingPageGuidesViewDesktop";

export const FPLandingPageGuidesViewMobile = (): JSX.Element =>
    <Background color={FrontColors.PROBATE_0}>
        <Flex
            direction="column"
            justifyContent="space-between"
            minHeight="100vh"
            gap="90px"
        >
            <SpacingColumn spacing={FrontSpacing.LARGE_2}>
                {/* TITLE */}
                <FPMarketingSectionTitle
                    color={FrontColors.NEUTRAL_18}
                    align="right"
                >
                    Read our probate guides
                </FPMarketingSectionTitle>

                {/* GUIDES */}
                {pipe(
                    fpLandingPageGuidesViewGuides,
                    array.mapWithIndex((i, guide) =>
                        <FPGuideMobile
                            key={i}
                            href={guide.href}
                            imageUrl={guide.imageUrl}
                            blurb={guide.blurb}
                        />
                    ),
                )}
            </SpacingColumn>
            
            {/* FOOTER */}
            <FPFooter />
        </Flex>
    </Background>;
